// 钉钉二维码登录
import React, { useEffect } from 'react';

import styles from './index.module.scss';

const Index = (props) => {
  useEffect(() => {
    const handleAuthCallback = (event) => {
      const data = event.data || {};
      if (data.source === 'DingTalkAuthCallback' && data.payload) {
        props.onSubmit({ code: data.payload.code });
      }
    };

    // 监听授权回调
    window.addEventListener('message', handleAuthCallback, false);

    return () => {
      // 移除监听事件
      window.removeEventListener('message', handleAuthCallback, false);
    };
  }, []);

  return (
    <div className={styles.DingTalkAuthWrapper}>
      <iframe
        src="/authorization/ding-talk"
        title="DingTalkCode"
        className={styles.DingTalkAuthCodeFrame}
      />
    </div>
  );
};

export default Index;
